<template>
	<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
		<!--input类型示例-->
		<FormItem prop="trackName">
			<FormItem prop="trackName">
				<Input style="width: 260px;" type="text" v-model="formInline.Name" placeholder="控件名称">
				<span slot="prepend">控件名称</span>
				</Input>
			</FormItem>
		</FormItem>
		<FormItem>
			<Button type="primary" @click="$emit('handleSubmit')">查询</Button>
		</FormItem>
		<div style="float: right;">
			<Button type="primary" @click="$emit('show','add')">控件添加</Button>
			<!-- <Button style="float: left;margin-left: 5px;" type="primary" @click="show('addExcel')">批量导入</Button> -->
		</div>
	</Form>
</template>

<script>
	export default {
		//props: ['param', 'url'],
		data() {
			return {
				formInline: {
					Name: ''
				},
				PriceList: [{
					Id: 0,
					Name: 'name'
				}]
			};
		},
		computed: {
			// pageParam: function() {
			// 	const _this = this;
			// 	const param = {
			// 		OperatorId: _this.formInline.OperatorId
			// 	}
			// 	return param
			// },
		},
		methods: {},
	}
</script>

<style>
</style>
